/**
 * collab-product.js
 * コラボ商品ページ共通ロジック
 * - バスボムコラボ (window.COLLAB_BATHBOMB)
 * - Twenty Fiveコラボ (window.COLLAB_TWENTYFIVE)
 * - ShamaStationコラボ (window.COLLAB_SHAMA)
 */

/* ============================================================
   バスボムコラボ
   ============================================================ */
const bathbombData = window.COLLAB_BATHBOMB;
if (bathbombData) {
  let qty = 1;

  document.getElementById('collabBathbombQtyMinus')
    ?.addEventListener('click', function () {
      if (qty <= 1) return;
      qty--;
      updateBathbombUI();
    });

  document.getElementById('collabBathbombQtyPlus')
    ?.addEventListener('click', function () {
      qty++;
      updateBathbombUI();
    });

  function updateBathbombUI() {
    var qtyEl = document.getElementById('collabBathbombQtyInput');
    var priceEl = document.getElementById('collabBathbombPriceTotal');
    var minusBtn = document.getElementById('collabBathbombQtyMinus');

    if (qtyEl) qtyEl.value = qty;
    if (priceEl) priceEl.innerHTML =
      '<span class="price-currency">¥</span>' + (bathbombData.price * qty).toLocaleString('ja-JP');
    if (minusBtn) minusBtn.disabled = qty <= 1;
  }

  document.getElementById('collabBathbombAtc')
    ?.addEventListener('click', async function () {
      this.disabled = true;
      this.textContent = '追加中...';
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: bathbombData.variantId,
            quantity: qty
          })
        });
        if (!res.ok) throw new Error('カート追加に失敗しました');
        window.location.href = '/cart';
      } catch (err) {
        alert(err.message);
        this.disabled = false;
        this.textContent = 'カートに追加';
      }
    });

  updateBathbombUI();
}

/* ============================================================
   Twenty Fiveコラボ
   ============================================================ */
const twentyfiveData = window.COLLAB_TWENTYFIVE;
if (twentyfiveData) {
  var counts = { orange_mango: 0, banana: 0 };

  var countIdMap = {
    orange_mango: 'collabTwentyfiveCountOrangeMango',
    banana: 'collabTwentyfiveCountBanana'
  };

  /* 在庫データ */
  var flavorInventory = {
    orange_mango: twentyfiveData.variants['オレンジマンゴー']?.inventory || 0,
    banana: twentyfiveData.variants['バナナ']?.inventory || 0
  };

  /* 在庫バッジID */
  var stockIdMap = {
    orange_mango: 'collabTwentyfiveStockOrangeMango',
    banana: 'collabTwentyfiveStockBanana'
  };

  /* 初期在庫チェック：在庫バッジ表示 + 在庫切れカードをグレーアウト */
  Object.keys(flavorInventory).forEach(function (flavor) {
    var stock = flavorInventory[flavor];
    var card = document.querySelector('[data-flavor="' + flavor + '"]');
    var stockEl = document.getElementById(stockIdMap[flavor]);
    var plusBtn = document.querySelector(
      '.collab-twentyfive-flavor-plus[data-flavor-key="' + flavor + '"]'
    );

    if (stock > 0) {
      if (stockEl) {
        stockEl.className = 'product-flavor-stock in-stock';
        stockEl.textContent = '在庫あり';
      }
    } else {
      if (stockEl) {
        stockEl.className = 'product-flavor-stock out-of-stock';
        stockEl.textContent = '在庫なし';
      }
      if (card) card.classList.add('is-soldout');
      if (plusBtn) plusBtn.disabled = true;
    }
  });

  document.querySelectorAll('.collab-twentyfive-flavor-plus')
    .forEach(function (btn) {
      btn.addEventListener('click', function () {
        var flavor = this.dataset.flavorKey;
        var stock = flavorInventory[flavor];
        if (stock <= 0 || counts[flavor] >= stock) return;
        counts[flavor]++;
        updateTwentyfiveUI();
      });
    });

  document.querySelectorAll('.collab-twentyfive-flavor-minus')
    .forEach(function (btn) {
      btn.addEventListener('click', function () {
        var flavor = this.dataset.flavorKey;
        if (counts[flavor] <= 0) return;
        counts[flavor]--;
        updateTwentyfiveUI();
      });
    });

  function updateTwentyfiveUI() {
    Object.keys(counts).forEach(function (flavor) {
      var el = document.getElementById(countIdMap[flavor]);
      if (el) el.textContent = counts[flavor];

      var stock = flavorInventory[flavor];

      var plusBtn = document.querySelector(
        '.collab-twentyfive-flavor-plus[data-flavor-key="' + flavor + '"]'
      );
      if (plusBtn) {
        plusBtn.disabled = stock <= 0 || counts[flavor] >= stock;
      }

      var minusBtn = document.querySelector(
        '.collab-twentyfive-flavor-minus[data-flavor-key="' + flavor + '"]'
      );
      if (minusBtn) minusBtn.disabled = counts[flavor] <= 0;

      /* 選択状態のカード表示 */
      var card = document.querySelector('[data-flavor="' + flavor + '"]');
      if (card && stock > 0) {
        card.classList.toggle('is-selected', counts[flavor] > 0);
      }
    });

    var total = Object.values(counts).reduce(function (a, b) { return a + b; }, 0);
    var totalEl = document.getElementById('collabTwentyfiveTotalQty');
    var priceEl = document.getElementById('collabTwentyfivePriceTotal');
    var atcBtn = document.getElementById('collabTwentyfiveAtc');

    var unitPrice = Object.values(twentyfiveData.variants)[0].price;

    if (totalEl) totalEl.textContent = total + '本';
    if (priceEl) priceEl.innerHTML =
      '<span class="price-currency">¥</span>' + (unitPrice * total).toLocaleString('ja-JP');
    if (atcBtn) atcBtn.disabled = total <= 0;
  }

  document.getElementById('collabTwentyfiveAtc')
    ?.addEventListener('click', async function () {
      var total = Object.values(counts).reduce(function (a, b) { return a + b; }, 0);
      if (total <= 0) return;

      this.disabled = true;
      this.textContent = '追加中...';

      try {
        // 最多本数のフレーバーを代表バリアントとして使用
        var dominantFlavor = Object.entries(counts)
          .filter(function ([, count]) { return count > 0; })
          .sort(function ([, a], [, b]) { return b - a; })[0][0];

        var flavorToTitle = {
          orange_mango: 'オレンジマンゴー',
          banana: 'バナナ'
        };

        var dominantTitle = flavorToTitle[dominantFlavor];
        var variantId = twentyfiveData.variants[dominantTitle].id;

        // Line Item Propertiesにフレーバー内訳を設定
        var properties = {};
        Object.entries(counts).forEach(function ([flavor, count]) {
          if (count <= 0) return;
          properties[flavorToTitle[flavor]] = count + '本';
        });

        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: total,
            properties: properties
          })
        });
        if (!res.ok) throw new Error('カート追加に失敗しました');
        window.location.href = '/cart';
      } catch (err) {
        alert(err.message);
        this.disabled = false;
        this.textContent = 'カートに追加';
      }
    });

  updateTwentyfiveUI();
}

/* ============================================================
   ShamaStationコラボ
   ============================================================ */
const shamaData = window.COLLAB_SHAMA;
if (shamaData) {
  let qty = 1;

  document.getElementById('collabShamaQtyMinus')
    ?.addEventListener('click', function () {
      if (qty <= 1) return;
      qty--;
      updateShamaUI();
    });

  document.getElementById('collabShamaQtyPlus')
    ?.addEventListener('click', function () {
      qty++;
      updateShamaUI();
    });

  function updateShamaUI() {
    var qtyEl = document.getElementById('collabShamaQtyInput');
    var priceEl = document.getElementById('collabShamaPriceTotal');
    var minusBtn = document.getElementById('collabShamaQtyMinus');

    if (qtyEl) qtyEl.value = qty;
    if (priceEl) priceEl.innerHTML =
      '<span class="price-currency">¥</span>' + (shamaData.price * qty).toLocaleString('ja-JP');
    if (minusBtn) minusBtn.disabled = qty <= 1;
  }

  document.getElementById('collabShamaAtc')
    ?.addEventListener('click', async function () {
      this.disabled = true;
      this.textContent = '追加中...';
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: shamaData.variantId,
            quantity: qty
          })
        });
        if (!res.ok) throw new Error('カート追加に失敗しました');
        window.location.href = '/cart';
      } catch (err) {
        alert(err.message);
        this.disabled = false;
        this.textContent = 'カートに追加';
      }
    });

  updateShamaUI();
}
